import ReferenceField from "./ReferenceField";

class ReferenceManyField extends ReferenceField {
    constructor(name) {
        super(name);
        this._type = 'reference_many';
    }
}

export default ReferenceManyField;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/Field/ReferenceManyField.js
 **/